import { AuthState } from "@okta/okta-auth-js";
import { Action, Dispatch } from "redux";
import { fetchUpdates, IUpdateRequestParams } from "./Operations";
import { Action as AnyAction } from "@reduxjs/toolkit";

export enum UpdateActionTypes {
  FetchUpdatesPending = "FETCH_UPDATES_PENDING",
  FetchedUpdates = "FETCHED_UPDATES",
  FetchUpdatesRejected = "FETCH_UPDATES_REJECTED",
  SetSortOrder = "SET_SORT_ORDER",
  ResetSortOrder = "RESET_SORT_ORDER",
  SetFilter = "SET_FILTER",
  ClearFilter = "CLEAR_FILTER",
  ClearAllFilters = "CLEAR_ALL_FILTERS"
}

export class FetchingUpdatesAction implements Action {
  public readonly type = UpdateActionTypes.FetchUpdatesPending;
}

export class FetchedUpdatesAction implements Action {
  public readonly type = UpdateActionTypes.FetchedUpdates;
  constructor(public payload: { updates: Api.IPagedResult<Api.INotificationViewModel> }) {  }
}

export class FetchUpdatesFailedAction implements Action {
  public readonly type = UpdateActionTypes.FetchUpdatesRejected;
  constructor(public payload: { error: string }) {  }
}

export class SetSortOrderAction implements Action {
  public readonly type = UpdateActionTypes.SetSortOrder;
  constructor(public payload: { orderBy: string }) {  }
}

export class ResetSortOrderAction implements Action {
  public readonly type = UpdateActionTypes.ResetSortOrder;
}

export class SetFilterAction implements Action {
  public readonly type = UpdateActionTypes.SetFilter;
  constructor(public payload: { field: string; value: any }) {  }
}

export class ClearFilterAction implements Action {
  public readonly type = UpdateActionTypes.ClearFilter;
  constructor(public payload: { field: string }) {  }
}

export class ClearAllFiltersAction implements Action {
  public readonly type = UpdateActionTypes.ClearAllFilters;
}

export type UpdateAction = FetchingUpdatesAction
  | FetchedUpdatesAction
  | FetchUpdatesFailedAction
  | SetSortOrderAction
  | ResetSortOrderAction
  | SetFilterAction
  | ClearFilterAction
  | ClearAllFiltersAction;

export const getUpdateListThunk: (auth: AuthState, requestParams: IUpdateRequestParams) => any =
  (auth, requestParams) => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new FetchingUpdatesAction());
    
    fetchUpdates(auth, requestParams)
      .then( (response:Api.INotificationsResponse) => {
          dispatch(new FetchedUpdatesAction( {updates: response.notifications} ));
      })
      .catch((errorResponse: Error) => {
        // tslint:disable-next-line:no-console
        console.error(errorResponse);
        dispatch(new FetchUpdatesFailedAction({error: errorResponse.message}));
      });
  }
}

// This is a thunk action creator for setSortOrder
export const setSortOrder: (orderBy: string) => any = (orderBy) => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new SetSortOrderAction({ orderBy }));
  };
};

// This is a thunk action creator for resetSortOrder
export const resetSortOrder: () => any = () => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new ResetSortOrderAction());
  };
};

// Filter action creators
export const setFilter = (field: string, value: any) => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new SetFilterAction({ field, value }));
  };
};

export const clearFilter = (field: string) => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new ClearFilterAction({ field }));
  };
};

export const clearAllFilters = () => {
  return (dispatch: Dispatch<AnyAction>) => {
    dispatch(new ClearAllFiltersAction());
  };
};
